import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicSort({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6.4 2.89l.01.11v10a1 1 0 01-2 0V5.41L2.8 7.04a1 1 0 01-1.32.08l-.1-.08a1 1 0 010-1.41l3.34-3.34a1 1 0 011.7.6zm4.18-.9a1 1 0 011 1v7.6l1.63-1.63a1 1 0 011.32-.09l.1.09a1 1 0 010 1.41l-3.34 3.34a1 1 0 01-1.7-.6L9.58 13V3a1 1 0 011-1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicSort.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicSort.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicSort svgRef={ref} {...props} />);
export default ForwardRef;
